module.exports = __webpack_public_path__ + "img/user-example.d477ba40.svg";